import { render, staticRenderFns } from "./BnHelpField.vue?vue&type=template&id=f9204d24&scoped=true&"
import script from "./BnHelpField.vue?vue&type=script&lang=js&"
export * from "./BnHelpField.vue?vue&type=script&lang=js&"
import style0 from "./BnHelpField.vue?vue&type=style&index=0&id=f9204d24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9204d24",
  null
  
)

export default component.exports